import React from "react";
import { useIntl } from "react-intl";

import { RemoteOption } from "lib/build/schema";

import { MultiSelect } from "src/common/components/MultiSelect";
import { IsLockedContext } from "src/features/forms/context/IsLockedContext";
import {
	useLogProp,
	useMessageProps,
	useValue
} from "src/features/forms/hooks/useField";
import { CommonProps } from "src/features/forms/types";

export const RemoteMultiSelectRenderer: React.FunctionComponent<
	CommonProps
> = directProps => {
	const isLocked = React.useContext(IsLockedContext);

	const options = useRemoteOptions();
	const [value, setValue] = useValue<string[] | undefined>(undefined);

	const onChangeValue = React.useCallback(
		(value: string[]) => {
			if (value.length === 0) {
				setValue(undefined);
			} else {
				setValue(value);
			}
		},
		[setValue]
	);

	return (
		<MultiSelect
			{...directProps}
			disabled={isLocked}
			options={options}
			value={value || []}
			onChangeValue={onChangeValue}
		/>
	);
};

function useRemoteOptions(): {
	label: string;
	value: string;
	disabled: boolean; // TODO this is not supported by MultiSelect
}[] {
	const { locale } = useIntl();
	const messageProps = useMessageProps();
	const remoteOptions = useLogProp<RemoteOption[]>(
		messageProps,
		"options",
		[]
	);
	return React.useMemo(
		() =>
			remoteOptions.map(option => ({
				value: option.value,
				label: option.labels[locale],
				disabled: option.inactive
			})),
		[remoteOptions, locale]
	);
}
